/**
 * Route Pending Component
 *
 * Default pending/loading UI for TanStack Router's pendingComponent.
 * Shown while a route's guard, loader or lazy chunk is running (after the
 * pendingMs threshold). Admin child routes render it `inFrame`, in the
 * outlet, so the header and sidebar stay; the router default fills the
 * screen.
 */

import { Spinner, loadingMessage } from '@/components/inputs';

export function RoutePendingComponent({ inFrame = false }: { inFrame?: boolean }) {
  if (inFrame) return <Spinner message={loadingMessage()} />;
  return <Spinner fullScreen size="lg" message={loadingMessage()} />;
}
